import $ from "jquery";
import moment from "moment";
import React, { Component } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Redirect } from "react-router-dom";
import { sDumi } from "s-dumi";
import Comm from "../comm/comm";
import Context from "../context/context";
import InvoiceByNum from "../controls/invoicebynum";
import Translation from "../translation/translation";

export default class InvoicesImport extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        this.ShowPackingLists = this.ShowPackingLists.bind(this);
        this.RenderPackingLists = this.RenderPackingLists.bind(this);
        this.RenderUnps = this.RenderUnps.bind(this);
        this.ShowByUnp = this.ShowByUnp.bind(this);
        this.ShowByPackingList = this.ShowByPackingList.bind(this);
        this.CreateInvoice = this.CreateInvoice.bind(this);
        this.RenderInvoice = this.RenderInvoice.bind(this);
        this.SetInvoice = this.SetInvoice.bind(this);
        this.CreateInvoiceInServer = this.CreateInvoiceInServer.bind(this);
        this.PrintElem = this.PrintElem.bind(this);
        this.ChooseReceiver = this.ChooseReceiver.bind(this);
        this.ShowUnps = this.ShowUnps.bind(this);
        this.SearchUnp = this.SearchUnp.bind(this);
        this.GetTotalNoVat = this.GetTotalNoVat.bind(this);
        this.AddNoVat = this.AddNoVat.bind(this);
        this.ShowInvoice = this.ShowInvoice.bind(this);
        this.NewInvoiceType = this.NewInvoiceType.bind(this);
        this.AddRow = this.AddRow.bind(this);
        this.DeleteRow = this.DeleteRow.bind(this);
        this.PaymentData = this.PaymentData.bind(this);
        this.GenerateAdvance = this.GenerateAdvance.bind(this);
        this.InvoiceTypeName = this.InvoiceTypeName.bind(this);

        this.state = {
            mode: "loading",
            unpPage: 0,
        };
    }

    InvoiceTypeName() {
        return <h2>{Translation.Trans(this.state.invoice.strType)}</h2>;
    }

    GenerateAdvance() {
        var sid = Context.GetContext().Sid;
        var invoice = {
            canEditRows: true,
            rows: [],
            totalNoVat: 0,
            novatReason: 0,
            paymentWay: 0,
            shopId: this.state.shops[0].id,
            printtype: "original",
            type: this.state.invoiceTypes.filter((x) => x.type === "advance")[0].id,
            strType: "advance",
            dealPlace: this.state.places[0].id,
            payTypeId: "-1",
        };

        invoice.date = moment().format("DD.MM.YYYY");
        invoice.vatdate = moment().format("DD.MM.YYYY");
        invoice.date_limit = moment().toDate();
        invoice.delivererName = this.state.companydata.data.find((x) => x.code === "_name").data;
        invoice.delivererCity = this.state.companydata.data.find((x) => x.code === "_city").data;
        invoice.delivererAddress = this.state.companydata.data.find((x) => x.code === "_address").data;
        invoice.delivererMol = this.state.companydata.data.find((x) => x.code === "_mol").data;
        invoice.delivererUic = this.state.companydata.data.find((x) => x.code === "_eik").data;
        invoice.delivererVat = this.state.companydata.data.find((x) => x.code === "_vat").data;
        var vatData = Comm.CallServerFunction("invoices/not_zero_vat", { session: sid }).result;

        this.setState({
            mode: "invoice",
            invoice: invoice,
            writeoffs: [],
            vatSize: vatData.dds,
            fixedVat: false,
        });
    }

    PaymentData(id) {
        var self = this;
        var b = self.state.ibans.filter((x) => x.id == self.state.invoice.payTypeId);
        if (b.length === 0) return <p>{Translation.Trans("bycash")}</p>;
        return (
            <p>
                {Translation.Trans("bybank")}
                <br />
                {b[0].bank} {b[0].iban} {b[0].bic}
            </p>
        );
    }

    AddRow() {
        var invoice = this.state.invoice;

        invoice.rows.push({
            rn: invoice.rows.length + 1,
            article: "",
            quantity: 0,
            unit: "",
            singlePrice: 0,
        });
        this.setState({ invoice: invoice });
    }

    DeleteRow(index) {
        var invoice = this.state.invoice;
        invoice.rows.splice(index - 1, 1);
        index = 1;
        invoice.rows.forEach((x) => (x.rn = index++));
        this.setState({ invoice: invoice });
    }

    AddNoVat() {
        var novat = window.prompt(Translation.Trans("novatreason"));
        if (novat) {
            var sid = Context.GetContext().Sid;
            Comm.CallServerFunction("invoices/add_vat_reason", { session: sid, reason: novat });
            var vatReasons = Comm.CallServerFunction("invoices/vat_reasons", { session: sid }).result;

            var invoice = this.state.invoice;
            invoice.novatReason = vatReasons.filter((x) => x.reason == novat)[0].id;
            this.setState({ vatReasons: vatReasons, invoice: invoice });
        }
    }

    componentDidMount() {
        var sid = Context.GetContext().Sid;
        var dates = Comm.CallServerFunction("n18_odit/date_range", { session: sid });
        this.dateMin = dates.date_range.min;
        this.dateMax = dates.date_range.max;
        var data = {
            session: sid,
            from: moment(this.dateMin, "YYYY-MM-DD").format("YYYYMMDD"),
            to: moment(this.dateMax, "YYYY-MM-DD").format("YYYYMMDD"),
        };
        var shops = Comm.CallServerFunction("n18_odit/shop_ids_by_date_range", data).shops;
        var partners = Comm.Partners(sid);

        var companydata = Comm.CallServerFunction("invoices/company_data_local", { session: sid });
        var vatReasons = Comm.CallServerFunction("invoices/vat_reasons", { session: sid }).result;
        var invoiceTypes = Comm.CallServerFunction("invoices/get_types", { session: sid }).result;
        var places = Comm.CallServerFunction("invoices/get_places_of_tran", { session: sid }).places;
        var ibans = Comm.CallServerFunction("invoices/accounts", {
            session: sid,
            visible_only: true,
        }).accounts;

        this.setState({
            shops: shops,
            shopId: shops[0].shop_id,
            accounts: Comm.Accounts(sid),
            partners: partners,
            receivers: partners,
            companydata: companydata,
            vatReasons: vatReasons,
            invoiceTypes: invoiceTypes,
            places: places,
            ibans: ibans,
        });
        this.ShowByUnp();
    }

    ShowByPackingList() {
        var sid = Context.GetContext().Sid;
        var partners = Comm.Partners(sid);

        this.setState(
            {
                partners: partners,
                partnerId: "-1",
                packingListPage: 0,
                packingListPageSize: 20,
            },
            () => this.ShowPackingLists()
        );
    }

    ShowPackingLists() {
        var sid = Context.GetContext().Sid;
        var partnerId = this.state.partnerId;
        var data = {
            session: sid,
            page: this.state.packingListPage,
            pagesize: this.state.packingListPageSize,
        };
        if (partnerId !== "-1") data.partner = partnerId;
        var packingLists = Comm.CallServerFunction("invoices/packing_lists_for_invoicing", data);
        this.setState({ packingLists: packingLists, mode: "packinglists" });
    }

    ShowUnps() {
        var sid = Context.GetContext().Sid;

        var data = {
            session: sid,
            shop_id: this.state.shopId,
            page: this.state.unpPage,
            page_size: this.state.unpPageSize,
        };

        var unps = Comm.CallServerFunction("invoices/shop_payments_for_invoice", data);

        this.setState({
            unps: unps,
            mode: "unps",
        });
    }
    ShowByUnp() {
        this.setState(
            {
                unpPage: 0,
                unpPageSize: 20,
            },
            () => this.ShowUnps()
        );
    }

    RenderPackingLists() {
        var self = this;
        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    {Translation.Trans("invoices")}{" "}
                    <button className="btn btn-primary" onClick={self.ShowByUnp}>
                        {Translation.Trans("byunp")}
                    </button>
                </div>
                <div className="panel-body">
                    <div className="col-md-10">
                        <InvoiceByNum ShowInvoice={self.ShowInvoice}></InvoiceByNum>
                    </div>
                    <div className="col-md-2">
                        <button className="btn btn-info" onClick={self.GenerateAdvance}>
                            {Translation.Trans("makeadvance")}
                        </button>
                    </div>
                    <div className="col-md-12">
                        <div className="col-md-12">
                            <select
                                id="ddlPartner"
                                className="form-control"
                                onChange={(e) =>
                                    self.setState({ partnerId: e.target.value }, self.ShowPackingLists)
                                }
                            >
                                <option value="-1"></option>
                                {this.state.partners.map((item) => (
                                    <option value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </div>

                        <p>&nbsp;</p>
                        <div className="col-md-12">
                            {this.state.packingLists && this.state.packingLists.packing_lists ? (
                                <table className="table table-striped">
                                    <tbody>
                                        {this.state.packingLists.packing_lists.map((item) => (
                                            <tr key={item.id}>
                                                <td>{item.date}</td>
                                                <td>{item.name}</td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="btn btn-default"
                                                        onClick={() => self.CreateInvoice(item.id, null)}
                                                    >
                                                        {Translation.Trans("invoice")}
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : null}
                        </div>
                        <div className="col-md-1">
                            {this.state.packingListPage > 0 ? (
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    onClick={() =>
                                        self.setState(
                                            { packingListPage: this.state.packingListPage - 1 },
                                            () => self.ShowPackingLists()
                                        )
                                    }
                                >
                                    &lt;&lt;
                                </button>
                            ) : null}
                        </div>
                        <div className="col-md-1">
                            {(this.state.packingListPage + 1) * this.state.packingListPageSize <
                            this.state.packingLists.count ? (
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    onClick={() =>
                                        self.setState(
                                            { packingListPage: this.state.packingListPage + 1 },
                                            () => self.ShowPackingLists()
                                        )
                                    }
                                >
                                    &gt;&gt;
                                </button>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    SearchUnp() {
        var unp = null;
        var sid = Context.GetContext().Sid;

        var data = {
            session: sid,
            unp: this.state.unp,
        };

        unp = Comm.CallServerFunction("invoices/shop_payments_for_invoice", data);
        if (!unp) this.setState({ showNotFound: true });
        else {
            this.CreateInvoice(null, unp.id);
        }
    }

    RenderUnps() {
        var self = this;
        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    {Translation.Trans("invoices")}{" "}
                    <button className="btn btn-primary" onClick={self.ShowByPackingList}>
                        {Translation.Trans("bypackinglist")}
                    </button>
                </div>
                <div className="panel-body">
                    <div className="col-md-10">
                        <InvoiceByNum ShowInvoice={self.ShowInvoice}></InvoiceByNum>
                    </div>
                    <div className="col-md-2">
                        <button className="btn btn-info" onClick={self.GenerateAdvance}>
                            {Translation.Trans("makeadvance")}
                        </button>
                    </div>

                    <div className="col-md-12">
                        <div className="col-md-6">
                            <label className="control-label">{Translation.Trans("shop")}</label>
                            <select
                                className="form-control"
                                value={self.state.shopId}
                                onChange={(e) =>
                                    self.setState({ shopId: e.target.value }, () => self.ShowUnps())
                                }
                            >
                                {self.state.shops.map((x) => (
                                    <option value={x.shop_id}>{x.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label className="control-label">{Translation.Trans("uniquenumber")}</label>
                            <input
                                type="text"
                                className="form-control"
                                value={self.state.unp}
                                onChange={(e) => self.setState({ unp: e.target.value })}
                            ></input>
                            {self.state.showNotFound ? (
                                <div className="alert alert-danger">{Translation.Trans("notfound")}</div>
                            ) : null}
                        </div>
                        <div className="col-md-2">
                            <label className="d-block">&nbsp;</label>
                            {(self.state.unp || "") !== "" ? (
                                <button className="btn btn-primary" onClick={self.SearchUnp}>
                                    {Translation.Trans("show")}
                                </button>
                            ) : null}
                        </div>
                        <p>&nbsp;</p>
                        <div className="col-md-12">
                            {this.state.unps && this.state.unps.result ? (
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{Translation.Trans("hour")}</th>
                                            <th>{Translation.Trans("uniquenumber")}</th>
                                            <th>{Translation.Trans("total")}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.unps.result.map((item) => (
                                            <tr key={item.id}>
                                                <td>{moment(item.moment).format("DD.MM.YYYY HH:mm")}</td>
                                                <td>{item.unique_nom}</td>
                                                <td>{item.sum}</td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="btn btn-default"
                                                        onClick={() => self.CreateInvoice(null, item.id)}
                                                    >
                                                        {Translation.Trans("invoice")}
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : null}
                        </div>
                        <div className="col-md-1">
                            {this.state.unpPage > 0 ? (
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    onClick={() =>
                                        self.setState({ unpPage: this.state.unpPage - 1 }, () =>
                                            self.ShowUnps()
                                        )
                                    }
                                >
                                    &lt;&lt;
                                </button>
                            ) : null}
                        </div>
                        <div className="col-md-1">
                            {(this.state.unpPage + 1) * this.state.unpPageSize < this.state.unps.count ? (
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    onClick={() =>
                                        self.setState({ unpPage: this.state.unpPage + 1 }, () =>
                                            self.ShowPackingLists()
                                        )
                                    }
                                >
                                    &gt;&gt;
                                </button>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    SetInvoice(field, value) {
        var invoice = this.state.invoice;
        invoice[field] = value;
        this.setState({ invoice: invoice });
    }

    RenderInvoice() {
        var self = this;
        return (
            <div id="dInvoiceContent">
                <div className="row" id="dCommandButtons">
                    <div className="col-xs-3">
                        <label className="control-label">{Translation.Trans("shop")}</label>
                        <select
                            className="form-control"
                            value={self.state.invoice.shopId}
                            onChange={(e) => self.SetInvoice("shopId", e.target.value)}
                        >
                            {self.state.shops.map((x) => (
                                <option value={x.shop_id}>{x.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-xs-2">
                        <label className="control-label">{Translation.Trans("type")}</label>
                        <select
                            className="form-control"
                            value={self.state.invoice.printtype}
                            onChange={(e) => self.SetInvoice("printtype", e.target.value)}
                        >
                            <option value="original">{Translation.Trans("original")}</option>
                            <option value="copy">{Translation.Trans("copy")}</option>
                        </select>
                    </div>
                    <div className="col-xs-7">
                        {this.state.invoice.invoiceNumber ? (
                            <button className="btn btn-primary" onClick={self.PrintElem}>
                                {Translation.Trans("print")}
                            </button>
                        ) : null}
                        <button className="btn btn-primary" onClick={self.CreateInvoiceInServer}>
                            {Translation.Trans("create")}
                        </button>

                        {(this.state.invoice.strType === "packing_list_debit" ||
                            this.state.invoice.strType === "shop_debit") &&
                        self.state.invoice.id
                            ? [
                                  <button className="btn btn-info" onClick={() => self.NewInvoiceType("ki")}>
                                      {Translation.Trans("ki")}
                                  </button>,
                                  <button className="btn btn-info" onClick={() => self.NewInvoiceType("di")}>
                                      {Translation.Trans("di")}
                                  </button>,
                              ]
                            : null}
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-6"></div>
                    <div className="col-xs-6">
                        <img src="/assets/img/InvoiceLogo.png" alt="" className="pull-right" />
                    </div>
                </div>

                {self.state.prevAdvances ? (
                    <div className="row">
                        <div className="col-xs-4">
                            <b>{Translation.Trans("forwriteoff")}</b>
                            <ul className="list-group">
                                {self.state.prevAdvances.map((i) => (
                                    <li className="list-group-item">
                                        <input
                                            type="checkbox"
                                            checked={
                                                self.state.writeoffs.filter((x) => x == i.invoice).length > 0
                                            }
                                            onChange={(e) => {
                                                var wo = self.state.writeoffs;
                                                if (e.target.checked) wo.push(i.invoice);
                                                else wo = wo.filter((x) => x != i.invoice);
                                                self.setState({ writeoffs: wo });
                                            }}
                                        ></input>
                                        {i.nom} /{moment(i.date, "YYYY-MM-DD").format("DD.MM.YYYY")}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ) : null}
                <div className="row">
                    <div className="col-xs-4">
                        <h2>{Translation.Trans("receiver")}</h2>
                    </div>
                    <div className="col-xs-4">{this.InvoiceTypeName()}</div>
                    <div className="col-xs-4">
                        <h2 className="pull-right">{Translation.Trans("deliverer")}</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-4" style={{ borderRight: "1px solid black" }}>
                        <div className="row">
                            <div className="col-xs-6">{Translation.Trans("name")}</div>

                            <div className="col-xs-6">
                                <select
                                    className="form-control"
                                    value={self.state.invoice.receiverId}
                                    onChange={(e) => self.ChooseReceiver(e.target.value)}
                                >
                                    <option></option>
                                    {this.state.receivers
                                        ? this.state.receivers.map((x) => (
                                              <option value={x.id}>{x.name}</option>
                                          ))
                                        : null}
                                </select>
                                {self.state.showvalidations && !self.state.invoice.receiverId ? (
                                    <div className="alert alert-danger">
                                        {Translation.Trans("entervalue")}
                                    </div>
                                ) : null}
                                <ul className="list-group">
                                    {this.state.found && this.state.found.result
                                        ? this.state.found.result.map((x) => (
                                              <li
                                                  className="list-group-item"
                                                  onClick={() => self.ChooseReceiver(x)}
                                                  style={{ cursor: "pointer" }}
                                              >
                                                  {x.name}
                                              </li>
                                          ))
                                        : null}
                                </ul>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-2">{Translation.Trans("address")}</div>
                            <div className="col-xs-5">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={self.state.invoice.receiverCity}
                                    onChange={(e) => self.SetInvoice("receiverCity", e.target.value)}
                                    readOnly="true"
                                ></input>
                            </div>
                            <div className="col-xs-5">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={self.state.invoice.receiverAddress}
                                    onChange={(e) => self.SetInvoice("receiverAddress", e.target.value)}
                                    readOnly="true"
                                ></input>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">{Translation.Trans("mol")}</div>
                            <div className="col-xs-6">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={self.state.invoice.receiverMol}
                                    onChange={(e) => self.SetInvoice("receiverMol", e.target.value)}
                                    readOnly="true"
                                ></input>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">
                                {Translation.Trans("eik")}/{Translation.Trans("egn")}
                            </div>
                            <div className="col-xs-6">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={self.state.invoice.receiverUic}
                                    onChange={(e) => self.SetInvoice("receiverUic", e.target.value)}
                                    readOnly="true"
                                ></input>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">{Translation.Trans("invat")}</div>
                            <div className="col-xs-6">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={self.state.invoice.receiverVat}
                                    onChange={(e) => self.SetInvoice("receiverVat", e.target.value)}
                                    readOnly="true"
                                ></input>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">{Translation.Trans("phone")}</div>
                            <div className="col-xs-6">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={self.state.invoice.receiverPhone}
                                    onChange={(e) => self.SetInvoice("receiverPhone", e.target.value)}
                                    readOnly="true"
                                ></input>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-4">
                        <div className="row">
                            <div className="col-xs-6">{Translation.Trans("number")}</div>
                            <div className="col-xs-6">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={self.state.invoice.invoiceNumber}
                                    readOnly="true"
                                ></input>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">{Translation.Trans("issuedate")}</div>
                            <div className="col-xs-6">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={self.state.invoice.date}
                                    readOnly="true"
                                ></input>
                                {/* <Datetime

                                    inputProps={{ placeholder: 'N/A', readOnly: "true", className: "form-control pointhand" }}
                                    dateFormat="DD.MM.YYYY"
                                    timeFormat=""
                                    onChange={(e) => self.SetInvoice('date', e)}
                                    value={this.state.invoice.date}
                                    closeOnSelect={true}
                                ></Datetime> */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">{Translation.Trans("dealplace")}</div>
                            <div className="col-xs-6">
                                <select
                                    className="form-control"
                                    value={self.state.invoice.dealPlace}
                                    onChange={(e) => self.SetInvoice("dealPlace", e.target.value)}
                                >
                                    {self.state.places.map((x) => (
                                        <option value={x.id}>{x.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-4" style={{ borderLeft: "1px solid black" }}>
                        <div className="row">
                            <div className="col-xs-6">{Translation.Trans("name")}</div>
                            <div className="col-xs-6">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={self.state.invoice.delivererName}
                                    onChange={(e) => self.SetInvoice("delivererName", e.target.value)}
                                    readOnly="true"
                                ></input>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-2">{Translation.Trans("address")}</div>
                            <div className="col-xs-5">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={self.state.invoice.delivererCity}
                                    onChange={(e) => self.SetInvoice("delivererCity", e.target.value)}
                                    readOnly="true"
                                ></input>
                            </div>
                            <div className="col-xs-5">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={self.state.invoice.delivererAddress}
                                    onChange={(e) => self.SetInvoice("delivererAddress", e.target.value)}
                                    readOnly="true"
                                ></input>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">{Translation.Trans("mol")}</div>
                            <div className="col-xs-6">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={self.state.invoice.delivererMol}
                                    onChange={(e) => self.SetInvoice("delivererMol", e.target.value)}
                                    readOnly="true"
                                ></input>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">
                                {Translation.Trans("eik")}/{Translation.Trans("egn")}
                            </div>
                            <div className="col-xs-6">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={self.state.invoice.delivererUic}
                                    onChange={(e) => self.SetInvoice("delivererUic", e.target.value)}
                                    readOnly="true"
                                ></input>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">{Translation.Trans("invat")}</div>
                            <div className="col-xs-6">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={self.state.invoice.delivererVat}
                                    onChange={(e) => self.SetInvoice("delivererVat", e.target.value)}
                                    readOnly="true"
                                ></input>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-6">{Translation.Trans("phone")}</div>
                            <div className="col-xs-6">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={self.state.invoice.delivererPhone}
                                    onChange={(e) => self.SetInvoice("delivererPhone", e.target.value)}
                                ></input>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        {self.state.showvalidations && self.state.invoice.rows.length === 0 ? (
                            <div className="alert alert-danger">
                                {Translation.Trans("enteratleastonerow")}
                            </div>
                        ) : null}
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>
                                        No
                                        {self.state.invoice.canEditRows ? (
                                            <button className="btn btn-info noPrint" onClick={self.AddRow}>
                                                +
                                            </button>
                                        ) : null}
                                    </th>
                                    <th>{Translation.Trans("articlename")}</th>
                                    <th>{Translation.Trans("quantity")}</th>
                                    <th>{Translation.Trans("unit")}</th>
                                    <th>{Translation.Trans("singleprice")}</th>
                                    <th>{Translation.Trans("totalprice")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {self.state.invoice.rows.map((x, i) => (
                                    <tr>
                                        <td>
                                            {x.rn}
                                            {self.state.invoice.canEditRows ? (
                                                <button
                                                    className="btn btn-info noPrint"
                                                    onClick={() => self.DeleteRow(x.rn)}
                                                >
                                                    X
                                                </button>
                                            ) : null}
                                        </td>
                                        <td>
                                            {self.state.invoice.canEditRows ? (
                                                <input
                                                    type="text"
                                                    value={x.article}
                                                    className="form-control"
                                                    onChange={(e) => {
                                                        var invoice = self.state.invoice;
                                                        invoice.rows[i].article = e.target.value;
                                                        self.setState({ invoice: invoice });
                                                    }}
                                                ></input>
                                            ) : (
                                                x.article
                                            )}
                                            {self.state.showvalidations && x.article == "" ? (
                                                <div className="alert alert-danger">
                                                    {Translation.Trans("entervalue")}
                                                </div>
                                            ) : null}
                                        </td>
                                        <td>
                                            {self.state.invoice.canEditRows ? (
                                                <input
                                                    type="number"
                                                    value={x.quantity}
                                                    className="form-control"
                                                    onChange={(e) => {
                                                        var invoice = self.state.invoice;
                                                        invoice.rows[i].quantity = e.target.value;
                                                        self.setState({ invoice: invoice });
                                                    }}
                                                ></input>
                                            ) : (
                                                x.quantity
                                            )}
                                            {self.state.showvalidations &&
                                            (parseFloat(x.quantity) != x.quantity ||
                                                parseFloat(x.quantity) == 0) ? (
                                                <div className="alert alert-danger">
                                                    {Translation.Trans("entervalue")}
                                                </div>
                                            ) : null}
                                        </td>
                                        <td>
                                            {self.state.invoice.canEditRows ? (
                                                <input
                                                    type="text"
                                                    value={x.unit}
                                                    className="form-control"
                                                    onChange={(e) => {
                                                        var invoice = self.state.invoice;
                                                        invoice.rows[i].unit = e.target.value;
                                                        self.setState({ invoice: invoice });
                                                    }}
                                                ></input>
                                            ) : (
                                                x.unit
                                            )}
                                            {self.state.showvalidations && x.unit == "" ? (
                                                <div className="alert alert-danger">
                                                    {Translation.Trans("entervalue")}
                                                </div>
                                            ) : null}
                                        </td>
                                        <td>
                                            {self.state.invoice.canEditRows ? (
                                                <input
                                                    type="number"
                                                    value={x.singlePrice}
                                                    className="form-control priceControl"
                                                    onChange={(e) => {
                                                        var invoice = self.state.invoice;
                                                        invoice.rows[i].singlePrice = e.target.value;
                                                        self.setState({ invoice: invoice });
                                                    }}
                                                ></input>
                                            ) : (
                                                x.singlePrice
                                            )}
                                            {self.state.showvalidations &&
                                            (parseFloat(x.singlePrice) != x.singlePrice ||
                                                parseFloat(x.singlePrice) == 0) ? (
                                                <div className="alert alert-danger">
                                                    {Translation.Trans("entervalue")}
                                                </div>
                                            ) : null}
                                        </td>
                                        <td>{(x.singlePrice * x.quantity).toFixed(2)}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td colSpan="2">{Translation.Trans("vatdate")}</td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={self.state.invoice.vatdate}
                                            readOnly="true"
                                        ></input>
                                        {/* <Datetime
                                            inputProps={{ placeholder: 'N/A', readOnly: "true", className: "form-control pointhand" }}
                                            dateFormat="DD.MM.YYYY"
                                            timeFormat=""
                                            onChange={(e) => self.SetInvoice('vatdate', e)}
                                            value={this.state.invoice.vatdate}
                                            closeOnSelect={true}
                                        ></Datetime> */}
                                    </td>
                                    <td colSpan="2">{Translation.Trans("novatsum")}</td>
                                    <td>{self.GetTotalNoVat().toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td colSpan="2">{Translation.Trans("duedate")}</td>
                                    <td>
                                        <Datetime
                                            inputProps={{
                                                placeholder: "N/A",
                                                readOnly: "true",
                                                className: "form-control pointhand",
                                            }}
                                            dateFormat="DD.MM.YYYY"
                                            timeFormat=""
                                            onChange={(e) => self.SetInvoice("date_limit", e)}
                                            value={this.state.invoice.date_limit}
                                            closeOnSelect={true}
                                        ></Datetime>
                                    </td>

                                    <td colSpan="2">{Translation.Trans("vatsum")}</td>
                                    <td>
                                        {self.state.invoice.novatReason > 0
                                            ? 0
                                            : (self.state.vatSize * self.GetTotalNoVat()).toFixed(2)}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        {Translation.Trans("novatreason")}
                                        <button className="btn btn-info noPrint" onClick={self.AddNoVat}>
                                            +
                                        </button>
                                    </td>
                                    <td>
                                        <select
                                            className="form-control"
                                            value={self.state.invoice.novatReason}
                                            onChange={(e) => self.SetInvoice("novatReason", e.target.value)}
                                        >
                                            {self.state.fixedVat && self.state.vatSize === 0 ? null : (
                                                <option value="0">
                                                    {self.state.vatSize * 100 + Translation.Trans("hasvat")}
                                                </option>
                                            )}
                                            {self.state.vatReasons &&
                                            (!self.state.fixedVat || self.state.vatSize === 0)
                                                ? self.state.vatReasons.map((x) => (
                                                      <option value={x.id}>{x.reason}</option>
                                                  ))
                                                : null}
                                        </select>
                                    </td>
                                    <td colSpan="2">{Translation.Trans("total")}</td>
                                    <td>
                                        <label id="lTotalFinal">
                                            {self.state.invoice.novatReason > 0
                                                ? self.GetTotalNoVat().toFixed(2)
                                                : (1.2 * self.GetTotalNoVat()).toFixed(2)}
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        {Translation.Trans("paymentway")}:
                                        {self.PaymentData(self.state.invoice.payTypeId)}
                                    </td>
                                    <td>
                                        <select
                                            className="form-control noPrint"
                                            value={self.state.invoice.payTypeId}
                                            onChange={(e) => self.SetInvoice("payTypeId", e.target.value)}
                                        >
                                            <option value="-1">{Translation.Trans("bycash")}</option>
                                            {this.state.ibans.map((x) => (
                                                <option value={x.id}>{x.iban}</option>
                                            ))}
                                        </select>
                                    </td>
                                    <td colSpan="3"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <label className="control-label">
                            {sDumi(
                                self.state.invoice.novatReason > 0
                                    ? self.GetTotalNoVat().toFixed(2)
                                    : (1.2 * self.GetTotalNoVat()).toFixed(2)
                            )}
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <input
                            className="form-control"
                            value={self.state.invoice.free_text}
                            onChange={(e) => self.SetInvoice("free_text", e.target.value)}
                            placeholder={Translation.Trans("freetext")}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-6">
                        {Translation.Trans("goodisreceivedby")}
                        <br />
                        <br />
                        <br />
                        {Translation.Trans("signature")}............................
                    </div>
                    <div className="col-xs-6">
                        {Translation.Trans("goodisdeliveredby")}
                        <br />
                        <br />
                        <br />
                        {Translation.Trans("signature")}............................
                    </div>
                </div>
            </div>
        );
    }

    ShowInvoice(inv) {
        //var sid = Context.GetContext().Sid;
        var self = this;

        var canEditRows =
            this.state.invoiceTypes.filter((x) => x.id === inv.invoice.type)[0].type !== "credit_shop";
        var invoice = {
            canEditRows: canEditRows,
            rows: [],
            totalNoVat: 0,
            novatReason: inv.invoice.vat_reason,
            fixedVat: true,
            paymentWay: 0,
            shopId: inv.invoice.shop_id,
            receiverId: inv.invoice.client,
            type: inv.invoice.type,
            selectedUnp: inv.invoice.shop_payment,
            packingListId: inv.packing_list,
            date: moment(inv.invoice.date, "YYYY-MM-DD").format("YYYYMMDD"),
            vatdate: moment(inv.invoice.tax_date, "YYYY-MM-DD").format("YYYYMMDD"),
            date_limit: moment(inv.invoice.date_limit, "YYYY-MM-DD").toDate(),
            free_text: inv.invoice.free_text,
            iban: inv.invoice.iban || "-1",
            id: inv.invoice.id,
            invoiceNumber: inv.invoice.nom,
            printtype: "original",
            //type: inv.invoice.type,
            strType: this.state.invoiceTypes.filter((x) => x.id === inv.invoice.type)[0].type,
            dealPlace: inv.place_of_tran,
        };

        var rn = 1;

        inv.positions.forEach((x) => {
            invoice.rows.push({
                rn: rn++,
                article: x.article_name,
                quantity: x.quantity,
                unit: x.unit_price,
                singlePrice: x.value || 0,
            });
        });

        invoice.delivererName = this.state.companydata.data.find((x) => x.code === "_name").data;
        invoice.delivererCity = this.state.companydata.data.find((x) => x.code === "_city").data;
        invoice.delivererAddress = this.state.companydata.data.find((x) => x.code === "_address").data;
        invoice.delivererMol = this.state.companydata.data.find((x) => x.code === "_mol").data;
        invoice.delivererUic = this.state.companydata.data.find((x) => x.code === "_eik").data;
        invoice.delivererVat = this.state.companydata.data.find((x) => x.code === "_vat").data;

        this.setState(
            {
                mode: "invoice",
                invoice: invoice,
            },
            () => self.ChooseReceiver(inv.invoice.client, false)
        );
    }

    NewInvoiceType(type) {
        var sid = Context.GetContext().Sid;
        var self = this;
        var invoice = self.state.invoice;
        switch (type) {
            case "di":
                invoice.type = this.state.invoiceTypes.filter((x) => x.type === "debit")[0].id;
                invoice.strType = "debit";
                break;
            case "ki":
                invoice.type = this.state.invoiceTypes.filter((x) => x.type === "credit")[0].id;
                invoice.strType = "credit";
                break;
            default:
                break;
        }

        invoice.date = moment().format("YYYYMMDD");
        invoice.vatdate = moment().format("YYYYMMDD");
        invoice.date_limit = moment().toDate();
        invoice.to_invoice = invoice.id;
        invoice.id = null;
        invoice.invoiceNumber = "";
        invoice.canEditRows = true;
        var vatData = Comm.CallServerFunction("invoices/not_zero_vat", { session: sid }).result;

        this.setState({
            mode: "invoice",
            fixedVat: true,
            invoice: invoice,
            vatSize: vatData.dds,
            writeoffs: [],
        });
    }

    CreateInvoice(packingListId, unpId) {
        var sid = Context.GetContext().Sid;
        var invoice = {
            canEditRows: unpId === null,
            rows: [],
            totalNoVat: 0,
            novatReason: 0,
            paymentWay: 0,
            shopId: this.state.shops[0].id,
            printtype: "original",
            type: 1,
            novat: false,
            dealPlace: this.state.places[0].id,
            payTypeId: "-1",
        };
        if (packingListId) {
            var vatData = Comm.CallServerFunction("invoices/not_zero_vat", { session: sid }).result;

            var data = Comm.InvoiceData({ session: sid, packing_list: packingListId });
            var rn = 1;
            this.setState({ packingListRows: data.positions, vatSize: vatData.dds, fixedVat: false });

            data.positions.forEach((x) => {
                invoice.rows.push({
                    rn: rn++,
                    id: x.id,
                    article: x.name,
                    quantity: x.quantity,
                    unit: x.unit_price,
                    singlePrice: x.value || 0,
                });
            });
            invoice.type = this.state.invoiceTypes.filter((x) => x.type === "packing_list_debit")[0].id;
            invoice.strType = "packing_list_debit";
        } else {
            data = Comm.CallServerFunction("invoices/payment_rows_for_invoice", {
                // no need of re-declaration of data
                session: sid,
                payment: unpId,
            }).result;
            this.setState({ vatSize: data[0].tax.dds, fixedVat: true });
            rn = 1; // no need of re-declaration of rn
            var novat = false;
            data.forEach((x) => {
                if (x.tax_group !== 2) novat = true;
                invoice.rows.push({
                    rn: rn++,
                    article: x.article,
                    quantity: x.qty,
                    unit: x.unit_price,
                    singlePrice: x.price || 0,
                });
            });
            invoice.type = this.state.invoiceTypes.filter((x) => x.type === "shop_debit")[0].id;
            invoice.strType = "shop_debit";
            invoice.novat = novat;
        }

        invoice.date = moment().format("DD.MM.YYYY");
        invoice.vatdate = moment().format("DD.MM.YYYY");
        invoice.date_limit = moment().toDate();
        invoice.delivererName = this.state.companydata.data.find((x) => x.code === "_name").data;
        invoice.delivererCity = this.state.companydata.data.find((x) => x.code === "_city").data;
        invoice.delivererAddress = this.state.companydata.data.find((x) => x.code === "_address").data;
        invoice.delivererMol = this.state.companydata.data.find((x) => x.code === "_mol").data;
        invoice.delivererUic = this.state.companydata.data.find((x) => x.code === "_eik").data;
        invoice.delivererVat = this.state.companydata.data.find((x) => x.code === "_vat").data;

        this.setState({
            mode: "invoice",
            invoice: invoice,
            selectedUnp: unpId,
            packingListId: packingListId,
            writeoffs: [],
        });
    }

    CreateInvoiceInServer() {
        this.setState({ showvalidations: true });
        if (!this.state.invoice.receiverId || (this.state.invoice.dealPlace || "") === "") return;
        var err = false;
        if (!this.state.invoice.rows || this.state.invoice.rows.length === 0) return;
        this.state.invoice.rows.forEach((x) => {
            if (
                x.article == "" ||
                parseFloat(x.quantity) != x.quantity ||
                parseFloat(x.quantity) == 0 ||
                x.unit == "" ||
                parseFloat(x.singlePrice) != x.singlePrice ||
                parseFloat(x.singlePrice) == 0
            )
                err = true;
        });
        if (err) return;

        var sid = Context.GetContext().Sid;

        var self = this;
        var data = {
            type: self.state.invoice.type,
            session: sid,
            shop_id: self.state.shopId,
            client: self.state.invoice.receiverId,
            date: moment().format("YYYYMMDD"),
            tax_date: moment().format("YYYYMMDD"),
            date_limit: moment(self.state.invoice.date_limit).format("YYYYMMDD"),
            free_text: self.state.invoice.free_text || "",
            place_of_tran: parseInt(self.state.invoice.dealPlace, 10),
            sub_invoices: JSON.stringify(self.state.writeoffs),
        };

        if (self.state.invoice.to_invoice) data.to_invoice = self.state.invoice.to_invoice;

        if (self.state.selectedUnp) data.shop_payment = self.state.selectedUnp;

        if (self.state.packingListId) {
            data.packing_list = self.state.packingListId;
        }

        var rows = [];

        self.state.invoice.rows.forEach((x) =>
            rows.push({
                name: x.article,
                quantity: x.quantity,
                unit_price: x.unit || "кг",
                value: x.singlePrice,
            })
        );

        data.prices = JSON.stringify(rows);

        if (self.state.invoice.novatReason != "0") data.vat_reason = self.state.invoice.novatReason;

        if (self.state.invoice.id) data.invoice = self.state.invoice.id;

        if (self.state.invoice.payTypeId != "-1")
            data.iban = self.state.ibans.filter((x) => x.id == self.state.invoice.payTypeId)[0].iban;

        console.log("saveinvoicenew", data);

        var invoiceNumber = Comm.CallServerFunction("invoices/save_invoice_new", data);

        this.SetInvoice("invoiceNumber", invoiceNumber.nom);
        this.SetInvoice("id", invoiceNumber.id);
    }

    PrintElem() {
        var mywindow = window.open("", "PRINT", "height=400,width=600");

        mywindow.document.write("<html><head><title>" + document.title + "</title>");
        mywindow.document.write('<link href="/assets/css/bootstrap.min.css" rel="stylesheet" />');

        mywindow.document.write('<link href="/assets/css/styles.css?v=1.4.0" rel="stylesheet" />');
        mywindow.document.write("<style>@media print {@page {size: landscape}}</style>");
        mywindow.document.write("</head><body >");

        mywindow.document.write('<div class="content-inner">');
        mywindow.document.write($("#dInvoiceContent").html());
        mywindow.document.write("</div>");
        mywindow.document.write(
            '<script src="/assets/js/jquery.3.2.1.min.js" type="text/javascript"></script>'
        );
        mywindow.document.write('<script src="/assets/js/bootstrap.min.js" type="text/javascript"></script>');
        mywindow.document.write('<script src="/assets/js/slovom.js" type="text/javascript"></script>');
        mywindow.document.write(
            `<script>
        $("#dCommandButtons").remove();
        $(".rdtDays").remove();
        
        $(".priceControl").each(function(i,e){
            $(e).val(parseFloat($(e).val()).toFixed(2));
        });
        $(".noPrint").each(function(i,e){
            $(e).replaceWith("");
        });

        $("input").each(function(i,e){
            var text = $(e).val();
            $(e).replaceWith($("<span>"+text+"</span>"))
        });
        $("select option:selected").each(function(i,e){
            
            var text = $(e).text();
            $($(e).parent()).replaceWith($("<span>"+text+"</span>"))
        });
        //$("#lSlovom").text(GenerateSlovom(` +
                $("#lTotalFinal").text() +
                `));



        window.focus();
        window.print();
        window.close();
        
        </script > `
        );
        mywindow.document.write("</body></html>");

        mywindow.document.close(); // necessary for IE >= 10
        // mywindow.focus(); // necessary for IE >= 10*/
        // mywindow.print();
        // mywindow.close();

        return true;
    }

    ChooseReceiver(id, nullWriteOffs = true) {
        var obj = this.state.receivers.filter((x) => x.id == id)[0];
        var sid = Context.GetContext().Sid;

        var receiver = Comm.CallServerFunction("invoices/get_client_data", { session: sid, id: id }).result;
        var invoice = this.state.invoice;
        invoice.receiverId = obj.id;
        invoice.receiverName = receiver.name;
        invoice.receiverCity = receiver.city;
        invoice.receiverAddress = receiver.address;
        invoice.receiverMol = receiver.mol;
        invoice.receiverUic = receiver.eic;
        invoice.receiverVat = receiver.vat_no;
        invoice.receiverPhone = receiver.phone;
        invoice.receiverReceiver = receiver.receaver;
        var writeoffs = [];

        var prevAdvances;
        if (invoice.id) {
            prevAdvances = Comm.CallServerFunction("invoices/sub_invoices_for_invoice", {
                session: sid,
                invoice: invoice.id,
            });
            if (!nullWriteOffs && prevAdvances.result)
                prevAdvances.result.forEach((x) => writeoffs.push(x.invoice));
        } else {
            prevAdvances = Comm.CallServerFunction("invoices/available_advances", {
                session: sid,
                client: id,
            });
        }

        this.setState({
            found: null,
            invoice: invoice,
            writeoffs: writeoffs,
            receiverObj: obj,
            prevAdvances: prevAdvances.result,
        });
    }

    GetTotalNoVat() {
        var total = 0;
        this.state.invoice.rows.forEach(
            (x) => (total += parseFloat((parseFloat(x.singlePrice) * parseFloat(x.quantity)).toFixed(2)))
        );
        return total;
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        switch (this.state.mode) {
            case "loading":
                return null;
            case "packinglists":
                return this.RenderPackingLists();
            case "unps":
                return this.RenderUnps();
            case "invoice":
                return this.RenderInvoice();
            default:
                return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/invoicesimport.js